





































































import { Component, Prop, Vue } from 'vue-property-decorator';
import {
  isPlanRecommended,
  isPlanSelected,
  toggleRecommend,
  toggleSelect,
} from '@common/helpers/plan-recommend';
import { isChangedPlan } from '@common/helpers/plan-highlight';

export interface PlanItemPlan {
  id: number | string;
  name?: string;
  treatment_policy?: string;
  recommended?: boolean;
  medicines?: Array<{ name: string; usage: string }>;
}

@Component
export default class PlanItem extends Vue {
  @Prop() plan!: PlanItemPlan;
  @Prop() prescriptionForm: any;
  @Prop() isDisabled: boolean;
  @Prop({ default: false }) isEditKarte: boolean;
  @Prop({ default: 'select' }) mode!: 'select' | 'view';
  @Prop({ default: 'plan-flex-80' }) className?: string;
  @Prop() from?: string;
  @Prop({ default: undefined }) changedPlanId?: number;

  private showMedicine: boolean = false;

  private get isChangedPlan(): boolean {
    return isChangedPlan(this.plan.id, this.changedPlanId);
  }

  private get isSelectedPlan() {
    return isPlanSelected(this.prescriptionForm.plans, this.plan.id);
  }

  /**
   * おすすめ！ reads the SAME place handleRecommendPlan writes to — the form's
   * entry for this plan — falling back to `plan.recommended`. It used to read
   * only `plan.recommended` (the catalogue), so any re-render from the form,
   * such as restoring a 一時保存 draft (No.173), showed the box empty while
   * `recommended: true` sat in the form. See isPlanRecommended.
   */
  private get isRecommendedPlan(): boolean {
    return isPlanRecommended(this.prescriptionForm && this.prescriptionForm.plans, this.plan);
  }

  /**
   * Visible when either the catalogue or the form recommends the plan. The OR
   * is deliberate: it can only ever show more boxes than before, never hide
   * one — a saved recommendation stays visible after the doctor unticks it,
   * and a tick of the doctor's own is never hidden behind a catalogue `false`.
   */
  private get isShowRecommend() {
    const recommended = this.plan.recommended || this.isRecommendedPlan;
    return (
      (this.isEditKarte && recommended) ||
      (!this.isEditKarte && this.mode === 'select') ||
      (recommended && this.mode === 'view') ||
      (this.isEditKarte &&
        this.prescriptionForm.old_type === 'reserve_prescription')
    );
  }

  private get isModeViewFromChatFrameWithPlanRecommend() {
    return (
      (this.mode === 'view' &&
        this.from &&
        this.from === 'chat' &&
        this.plan.recommended) ||
      !this.from
    );
  }

  togglePlanDetail() {
    this.showMedicine = !this.showMedicine;
  }

  handleSelectPlan($event: any, plan) {
    this.prescriptionForm.plans = toggleSelect(this.prescriptionForm.plans, plan.id);
  }

  // Read (isRecommendedPlan) and write go through the same id matcher —
  // see plan-recommend.ts. They used to differ, which let a restored '7386'
  // be read as ticked but toggled by appending a duplicate entry.
  handleRecommendPlan($event: any, plan) {
    this.prescriptionForm.plans = toggleRecommend(this.prescriptionForm.plans, plan.id);
  }
}
